import { useCallback } from "react";

/**
 * 【カスタムフック】: 添付アイテムのホバー状態管理
 * 【機能概要】: ファイル添付アイテムやドキュメント添付アイテムのホバー時に
 *               削除ボタンと通常アイコンの表示を切り替える
 * 【設計方針】: ホバー状態の管理ロジックを再利用可能にする
 *               CSSクラス操作により、スタイルを一元管理
 */
export const useAttachmentHover = (styles: {
  attachmentIconVisible: string;
  attachmentIconHidden: string;
}) => {
  /**
   * 【ホバー時処理】: マウスエンター時に削除ボタンを表示し、通常アイコンを非表示にする
   * @param deleteButtonTestId - 削除ボタンのdata-testid
   * @param normalIconTestId - 通常アイコンのdata-testid
   * @param element - イベントが発生した要素
   */
  const handleMouseEnter = useCallback(
    (deleteButtonTestId: string, normalIconTestId: string, element: HTMLElement) => {
      const deleteButtonElement = element.querySelector(`[data-testid="${deleteButtonTestId}"]`);
      const normalIconElement = element.querySelector(`[data-testid="${normalIconTestId}"]`);

      if (deleteButtonElement !== null && normalIconElement !== null) {
        deleteButtonElement.classList.remove(styles.attachmentIconHidden);
        deleteButtonElement.classList.add(styles.attachmentIconVisible);
        normalIconElement.classList.remove(styles.attachmentIconVisible);
        normalIconElement.classList.add(styles.attachmentIconHidden);
      }
    },
    [styles],
  );

  /**
   * 【ホバー解除時処理】: マウスリーブ時に削除ボタンを非表示にし、通常アイコンを表示する
   * @param deleteButtonTestId - 削除ボタンのdata-testid
   * @param normalIconTestId - 通常アイコンのdata-testid
   * @param element - イベントが発生した要素
   */
  const handleMouseLeave = useCallback(
    (deleteButtonTestId: string, normalIconTestId: string, element: HTMLElement) => {
      const deleteButtonElement = element.querySelector(`[data-testid="${deleteButtonTestId}"]`);
      const normalIconElement = element.querySelector(`[data-testid="${normalIconTestId}"]`);

      if (deleteButtonElement !== null && normalIconElement !== null) {
        deleteButtonElement.classList.remove(styles.attachmentIconVisible);
        deleteButtonElement.classList.add(styles.attachmentIconHidden);
        normalIconElement.classList.remove(styles.attachmentIconHidden);
        normalIconElement.classList.add(styles.attachmentIconVisible);
      }
    },
    [styles],
  );

  return {
    handleMouseEnter,
    handleMouseLeave,
  };
};
